const isListItemExpand = ( expandClass, listItem ) => listItem.classList.contains( expandClass );

const expandItem = (expandClass, clickedItem, expendingItem, container, closeButton = clickedItem) => {
	const isExpand = isListItemExpand( expandClass, container );
	const isOnClose = closeButton && isExpand;

	if ( !isExpand || isOnClose )
	{
		expendingItem.style.height = `${expendingItem.firstChild.offsetHeight}px`;
	}

	if ( !isExpand )
	{
		expendingItem.addEventListener(`transitionend`, () => {
			if ( isListItemExpand( expandClass, container ) )
			{
				expendingItem.style.height = `auto`;
			}
		}, {once: true});

		container.classList.add(expandClass);
	}

	if ( isOnClose )
	{
		container.classList.remove(expandClass);
		setTimeout(() => expendingItem.style.height = ``, 10);
	}
};


export const initSectionExpandingText = () => {
	// const components = Array.from( document.querySelectorAll( `section.expanding-text` ) );
	//
	// if ( components )
	// {
	//	
	// }
	document.addEventListener(`click`, ({target}) => {
		const listItem = target.closest(`section.expanding-text > ul > li`);

		if ( listItem )
		{
			const expendingItem = listItem.querySelector(`div.info-wrapper`);
			const closeButton = target.closest(`div.head`);

			expandItem(`expand-item`, listItem, expendingItem, listItem, closeButton);
		}
	});
};
